export default "__VITE_ASSET__f2e3a6e4__"